/* BeYou Organics: header menu, sticky header offset, product form, cart quantity, sort, newsletter popup */
(function () {
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} },
    sget: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    sset: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  };

  // Header: keep the green bar stuck while the announcement scrolls away; mobile menu toggle
  var hdr = document.querySelector('[data-byo-hdr]');
  if (hdr) {
    var section = hdr.closest('.shopify-section');
    var announce = section && section.querySelector('.byo-announce');
    var setTop = function () { if (section) section.style.top = -(announce ? announce.offsetHeight : 0) + 'px'; };
    if (section) { section.style.position = 'sticky'; section.style.zIndex = '60'; setTop(); window.addEventListener('resize', setTop); }
    var burger = hdr.querySelector('[data-byo-burger]');
    if (burger) burger.addEventListener('click', function () {
      var open = hdr.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  }

  // Quantity steppers (product page and cart)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-byo-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var min = input.min === '' ? 1 : +input.min;
    input.value = Math.max(min, (+input.value || 0) + (+btn.getAttribute('data-byo-qty')));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-byo-autosubmit]')) e.target.form.submit();
    if (e.target.matches('[data-byo-sort]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });

  // Product page: variant select updates price, image, button; thumbnails swap the main image
  var mainImg = document.querySelector('[data-byo-main-img]');
  var showImg = function (src) { if (mainImg && src) { mainImg.removeAttribute('srcset'); mainImg.src = src; } };
  document.querySelectorAll('[data-byo-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      showImg(b.getAttribute('data-byo-thumb'));
      document.querySelectorAll('[data-byo-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
    });
  });
  var variant = document.querySelector('[data-byo-variant]');
  if (variant) variant.addEventListener('change', function () {
    var o = variant.options[variant.selectedIndex];
    var price = document.querySelector('[data-byo-price]');
    if (price) price.innerHTML = (o.dataset.compare ? '<s>' + o.dataset.compare + '</s>' : '') + o.dataset.price;
    var atc = document.querySelector('[data-byo-atc]');
    if (atc) { var ok = o.dataset.available === 'true'; atc.disabled = !ok; atc.textContent = ok ? 'Add to cart' : 'Sold out'; }
    showImg(o.dataset.img);
    var url = new URL(window.location.href); url.searchParams.set('variant', variant.value); history.replaceState(null, '', url.toString());
  });

  // Background videos: play when on screen, pause when off (saves battery on phones)
  var vids = document.querySelectorAll('.byo-glow-video, .byo-ritual-video');
  if ('IntersectionObserver' in window && vids.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { var p = en.target.play(); if (p && p.catch) p.catch(function () {}); } else en.target.pause(); });
    }, { threshold: 0.15 });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
  }

  // Newsletter popup: after the delay or on exit intent; once per visit, at most 3 times, never again after signing up
  var pop = document.querySelector('[data-byo-pop]');
  if (pop && !window.Shopify?.designMode) {
    var KEY = 'byoPopShown', DONE = 'byoPopDone';
    var shown = false;
    var open = function () {
      if (shown) return;
      shown = true;
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      store.sset(KEY, '1');
      store.set(KEY, String((+store.get(KEY) || 0) + 1));
      var f = pop.querySelector('input[type=email]'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 350);
    };
    var close = function () { pop.classList.remove('is-open'); setTimeout(function () { pop.hidden = true; }, 350); };
    pop.querySelectorAll('[data-byo-pop-close]').forEach(function (b) { b.addEventListener('click', close); });
    pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });
    if (pop.querySelector('[data-byo-pop-success]') || pop.querySelector('.byo-form-msg--error')) { store.set(DONE, pop.querySelector('[data-byo-pop-success]') ? '1' : store.get(DONE)); open(); }
    else if (!store.get(DONE) && !store.sget(KEY) && (+store.get(KEY) || 0) < 3) {
      setTimeout(open, (+pop.getAttribute('data-delay') || 8) * 1000);
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) open(); });
    }
  }
})();
